import React from 'react'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { apiConfig } from 'services/api'
import { sanitize } from 'utils/sanitize'
import { toast } from 'react-toastify'
import { DeleteAccountProps, DeleteAccountStep } from './DeleteAccount.types'

export const useDeleteAccount = () => {
	const [hasAgreed, setHasAgreed] = React.useState(false)
	const [isLoading, setLoading] = React.useState(false)

	const [step, setStep] = React.useState<DeleteAccountStep>('deleteForm')
	const { location } = useHistory()
	const [payload, setPayload] = React.useState<DeleteAccountProps>({
		email: '',
		phone: '',
		reasons: [],
		comments: '',
		code: '',
	})

	const isLastStep = step === 'finished'
	const isValidEmail = payload.email && payload.email.includes('@')
	const isInvalidForm = !payload.phone && !isValidEmail

	const handleGetVerificationCode = async () => {
		try {
			setLoading(true)
			await apiConfig({
				baseURL: process.env.REACT_APP_BASE_API,
			}).post('/account-deletion/verification-code', {
				...sanitize({ email: payload.email, phone: payload.phone }),
			})
			setStep('codeVerify')
			toast.success('Código enviado')
		} catch (error) {
			console.error(error)
			toast.error('Hubo un error al enviar el código')
		} finally {
			setLoading(false)
		}
	}

	const handleSubmitCode = async () => {
		try {
			setLoading(true)
			await apiConfig({
				baseURL: process.env.REACT_APP_BASE_API,
			}).post('/account-deletion/verify-and-notify', sanitize(payload))
			toast.success('Proceso de eliminación de cuenta iniciado')
			setStep('finished')
		} catch (error) {
			console.error(error)
			toast.error('Hubo un error al enviar el código')
		} finally {
			setLoading(false)
		}
	}

	const handleNext = () => {
		if (step === 'deleteForm') {
			handleGetVerificationCode()
		}
		if (step === 'codeVerify') {
			handleSubmitCode()
		}
	}

	const handlePrev = () => {
		if (step === 'deleteForm') {
			return
		}
		if (step === 'codeVerify') {
			return setStep('deleteForm')
		}
	}

	useEffect(() => {
		if (location.pathname === '/eliminar-cuenta' && location.search) {
			const base64Code = location.search.split('?payload=').pop() || ''
			const searchPayload = window.atob(base64Code)

			const parsedPayload = JSON.parse(searchPayload)
			setPayload({ ...payload, ...parsedPayload })
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return {
		step,
		payload,
		isLoading,
		hasAgreed,
		isLastStep,
		isInvalidForm,
		setHasAgreed,
		handlePrev,
		handleNext,
		setPayload,
		handleGetVerificationCode,
	}
}
